@if (form) {
	<form [formGroup]="form">
		<div class="input-group">
			<label class="toggle">
				<toggle-button data-test="briefing-toggle" formControlName="important" />
				{{ "general.briefing" | translate }}
			</label>
		</div>

		<ng-container *hasFeature="['Dar']">
			<div class="input-group">
				<label class="toggle">
					<toggle-button data-test="initialize-dar-toggle" formControlName="initializeDar" />
					{{ "general.initializeDar" | translate }}
				</label>
			</div>
		</ng-container>

		@if (!task?.unplanned) {
			<div class="input-group">
				<label class="toggle">
					<toggle-button data-test="is-executed-toggle" formControlName="executed" />
					{{ "tasks.isExecuted" | translate }}
				</label>
			</div>
		}

		@if (form?.get("executed")?.value) {
			<ngx-dynamic-form [config]="formConfig" [form]="form.get('evaluationForm')" />
		}

		<div class="form__notes">
			<label class="vertical">
				<span>{{ "general.remarks" | translate }}</span>
				<textarea data-test="notes-textarea" formControlName="notes"></textarea>
			</label>
		</div>

		<ng-container *hasFeature="['Dar']">
			@if (form.get("initializeDar").value) {
				<div class="actions-list">
					<label>
						<span>{{ "general.darActions" | translate }}</span>

						<ic-dar-actions-form formControlName="darActions" />
					</label>
				</div>
			}
		</ng-container>

		@if (!task?.completed && task?.hasUserHandlePermission) {
			<action-button
				data-test="complete-care-task-button"
				icon="fa fa-floppy-o"
				[disabled]="form.invalid || form.disabled"
				(action)="save(form)"
			/>
		}
	</form>
}
